import { render, staticRenderFns } from "./AddAntecedent.vue?vue&type=template&id=444569ba&scoped=true"
import script from "./AddAntecedent.vue?vue&type=script&lang=js"
export * from "./AddAntecedent.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&id=444569ba&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444569ba",
  null
  
)

export default component.exports